import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { CuttingCustomHole, PositioningTypeEnum } from 'cloud-shared-lib';

export interface FastenersDialogData {
  holes: CuttingCustomHole[];
  positionType: PositioningTypeEnum;
}

@Component({
  templateUrl: './fasteners-schema-dialog.component.html',
})
export class FastenersSchemaDialogComponent implements OnInit {
  dataSource: MatTableDataSource<CuttingCustomHole> = new MatTableDataSource<CuttingCustomHole>([]);
  displayedColumns = ['x', 'y', 'z', 'diameter', 'depth', 'type'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: FastenersDialogData) {}

  ngOnInit(): void {
    this.dataSource.data = this.data.holes;
  }
}
